import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class NotificationService {
  static getNotifications(page) {
    return RetailerApiClient.get('notifications?page=' + page)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  static markAsRead(id) {
    return RetailerApiClient.patch('notifications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  static delete(id) {
    return RetailerApiClient.delete('notifications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
